export default "__VITE_ASSET__BFqhbAbC__"